import { dbService } from './db';
import { syncService } from './syncService';
import { useLoaderData } from "react-router";
import React, { useRef, useState, useEffect } from 'react';
import { useOutletContext } from "react-router";
import { userService } from './userService';
import { useOnlineStatus } from './connectivityService';

import {
  Button,
  Field,
  Dialog,
  DialogPanel,
  DialogTitle,
  Fieldset,
  Textarea,
} from '@headlessui/react';


export async function clientLoader({ params }) {
  
}

export function NewNote({ isOpen, setIsOpen, customer }) {
  const { activeAccount } = useOutletContext();
  const isOnline = useOnlineStatus();

  const [session, setSession] = useState({});

  const [note, setNote] = useState('');
  
   useEffect(() => {
      const fetchData = async () => {
        setSession(await userService.getSession());
      };
      fetchData();
    }, []);

  async function save() {
    let noteAction = {
      data_area: customer.data_area, 
      customer_number: customer.customer_number,
      customer_name: customer.name,
      note: note,
      party_id: session.party_id,
      id: crypto.randomUUID(),
    }
    
    let db = await dbService.createDB();
    await db.put("customerNoteAction", noteAction);
    
    if (isOnline) {
      await syncService.syncCustomerNoteActions(activeAccount);
    }
    setIsOpen(false);
  }

  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-lg space-y-2 bg-black/90 p-6 rounded-lg border border-2 border-white text-white">
            <DialogTitle className="font-bold">New Note - {customer?.name}</DialogTitle>
            <div>
              <Fieldset className="space-y-2">
                <Field>
                  <Textarea placeholder="Note" className="w-full block py-1 px-2 border border-1 rounded-lg w-full text-white" name="notes" value={note} onChange={(e) => setNote(e.target.value)}></Textarea>
                </Field>
              </Fieldset>
            </div>

            <div className="flex gap-2">
              <Button className="rounded-md w-35 bg-white text-pvs-gray m-2 p-2" onClick={() => setIsOpen(false)}>Cancel</Button>
              <Button className="rounded-md w-35 bg-white text-pvs-gray m-2 p-2" onClick={() => save()}>Save</Button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}

